import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WPEmptyStates from "../../packages/WPEmptyStates";
import { NoFileIcon } from "../../assets/icons";

const NO_FILE_STEP_KEYS = [
  "emptyState.emptyStateStepUpload",
  "emptyState.emptyStateStepMap",
  "emptyState.emptyStateStepSetConditions",
  "emptyState.emptyStateStepProceed",
];

const EmptyStateContent = () => {
  const { t } = useTranslation();
  const noFileSteps = useMemo(
    () =>
      NO_FILE_STEP_KEYS.map((stepKey) => ({ key: stepKey, label: t(stepKey) })),
    [t],
  );

  return (
    <div className="analyse-data-empty-state">
      <WPEmptyStates
        className="analyse-data-empty-state__message"
        icon={NoFileIcon}
        titleMsg={t("emptyState.noFileUploadedHeader")}
        description={t("emptyState.noFileUploadedDescription")}
      />

      <div className="analyse-data-empty-state__steps">
        {noFileSteps.map((step, index) => (
          <div key={step.key} className="analyse-data-empty-state__step-item">
            <span className="analyse-data-empty-state__step-number">
              {index + 1}
            </span>
            <span className="analyse-data-empty-state__step-label">
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmptyStateContent;
